import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "preview", "input" ]

  connect() {
    console.log('connect')
  }

  choose(event) {
    this.inputTarget.click();
  }

  preview(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = document.createElement("img");
      img.src = e.target.result;
      // add css classes to the img element
      img.classList.add("size-20", "rounded-full", "object-cover");
      this.previewTarget.innerHTML = "";
      this.previewTarget.appendChild(img);
    };
    reader.readAsDataURL(file);
  }
}
